/* MMW purchase-mode selector + delivery fee for the wall configurator.
   3-way mode (Panels only / Install only $125/panel / Combo - highlighted best value) and a
   delivery-fee estimator: customer types an address, we geocode it (keyless Photon),
   measure the distance from Los Angeles and charge $150 base + per-mile. Recomputes
   the breakdown / total / CTA. Runs AFTER the main calc() via event bubbling. Isolated. */
(function(){
  function $(id){ return document.getElementById(id); }
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function(){
    var panelsEl=$('wcPanels'), breakEl=$('wcBreak'), priceEl=$('wcPrice'), buyEl=$('wcBuy'),
        finishEl=$('wcFname'), install=$('wcInstall'), controls=document.querySelector('.wc-controls'),
        widthEl=$('wcWidth');
    if(!panelsEl||!breakEl||!priceEl||!controls) return;

    var LABOR_OURS=75, LABOR_ONLY=125;          // $/panel
    var SHOP_LAT=34.0522, SHOP_LNG=-118.2437;   // Los Angeles origin (update to real shop if needed)
    var DELIVERY_BASE=150, MILE_RATE=2, ROAD=1.3; // $150 base + $2/mile (road-approx factor)
    var mode='panels', deliveryFee=0, deliveryMiles=null, cache=null;

    var instRow=(install&&install.closest)?install.closest('.wc-check'):null;
    if(install) install.checked=false;
    if(instRow) instRow.style.display='none';
    var led=$('wcLED'); if(led){ led.checked=false; var ledRow=led.closest?led.closest('.wc-check'):null; if(ledRow) ledRow.style.display='none'; }

    if(!document.getElementById('wcModeCss')){
      var st=document.createElement('style'); st.id='wcModeCss';
      st.textContent='.wc-mode{display:flex;flex-direction:column;gap:12px;margin:0 0 4px}'+
        '.wc-modeseg{display:grid;grid-template-columns:1fr 1fr 1.35fr;gap:10px;align-items:stretch}'+
        '.wc-modeseg button{position:relative;display:flex;flex-direction:column;gap:5px;align-items:flex-start;text-align:left;padding:14px 14px;border:1.5px solid rgba(0,0,0,.12);border-radius:14px;background:#fff;cursor:pointer;font:inherit;color:#1d1d1f;font-weight:700;font-size:1rem;transition:.15s}'+
        '.wc-modeseg button small{font-weight:500;font-size:.8rem;color:#6e6e73;line-height:1.25}'+
        '.wc-modeseg button:hover{border-color:rgba(0,0,0,.28)}'+
        '.wc-modeseg button.is-on{border-color:#0071e3;background:rgba(0,113,227,.06);box-shadow:0 0 0 3px rgba(0,113,227,.14)}'+
        '.wc-modeseg .wc-save{display:inline-block;margin-top:2px;font-size:.78rem;font-weight:800;color:#0a7d33;background:rgba(10,125,51,.12);padding:3px 10px;border-radius:999px}'+
        '#wcBreak .wc-save-line b{color:#0a7d33}'+
        '.wc-modeseg button[data-mode=combo]{border-color:#0a7d33;border-width:2px;background:linear-gradient(180deg,rgba(10,125,51,.10),rgba(10,125,51,.02));box-shadow:0 10px 22px -10px rgba(10,125,51,.45);padding-top:22px;font-size:1.08rem}'+
        '.wc-modeseg button[data-mode=combo] small{font-size:.84rem}'+
        '.wc-modeseg button[data-mode=combo]:hover{border-color:#0a7d33}'+
        '.wc-modeseg button[data-mode=combo].is-on{border-color:#0a7d33;background:linear-gradient(180deg,rgba(10,125,51,.17),rgba(10,125,51,.05));box-shadow:0 0 0 3px rgba(10,125,51,.22),0 12px 26px -10px rgba(10,125,51,.55)}'+
        '.wc-modeseg .wc-ribbon{position:absolute;top:-11px;left:14px;background:#0a7d33;color:#fff;font-size:.64rem;font-weight:800;letter-spacing:.05em;padding:3px 10px;border-radius:999px;box-shadow:0 3px 8px rgba(10,125,51,.4)}'+
        '.wc-deliv{display:flex;gap:8px;flex-wrap:wrap;align-items:center}'+
        '.wc-deliv input{flex:1;min-width:180px;padding:12px 14px;border:1px solid var(--line);border-radius:12px;background:#fff;font:inherit;font-size:1rem;color:var(--ink)}'+
        '.wc-deliv input:focus{outline:none;border-color:var(--blue);box-shadow:0 0 0 3px rgba(0,113,227,.18)}'+
        '.wc-deliv button{padding:12px 18px;white-space:nowrap}'+
        '@media(max-width:560px){.wc-modeseg{grid-template-columns:1fr}.wc-modeseg button[data-mode=combo]{padding-top:22px}}';
      document.head.appendChild(st);
    }

    var wrap=document.createElement('div'); wrap.className='wc-mode';
    wrap.innerHTML='<span class="wc-lab">What do you need?</span>'+
      '<div class="wc-modeseg">'+
        '<button type="button" data-mode="panels" class="is-on">Panels only<small>DIY &mdash; just the panels, shipped to you</small></button>'+
        '<button type="button" data-mode="install">Install only<small>You already have panels &middot; $125/panel</small></button>'+
        '<button type="button" data-mode="combo"><span class="wc-ribbon">&#9733; BEST VALUE</span>Panels + install<small>We supply &amp; install it all &mdash; done for you</small><span class="wc-save">Best value</span></button>'+
      '</div>';
    controls.insertBefore(wrap, controls.firstChild);
    var btns=wrap.querySelectorAll('button[data-mode]'), saveBadge=wrap.querySelector('.wc-save');

    var df=document.createElement('div'); df.className='wc-field';
    df.innerHTML='<span class="wc-lab">Delivery</span>'+
      '<div class="wc-deliv"><input type="text" id="wcAddr" placeholder="Delivery address (street, city, ZIP)" autocomplete="off"><button type="button" id="wcAddrGo" class="lp-cta">Calculate</button></div>'+
      '<small class="wc-hint" id="wcDelivNote">Delivery starts at $'+DELIVERY_BASE+' + per-mile from Los Angeles. Enter your address for an estimate &mdash; final fee confirmed at checkout.</small>';
    controls.appendChild(df);
    var addr=$('wcAddr'), addrGo=$('wcAddrGo'), dNote=$('wcDelivNote');

    function money(n){ return '$'+Math.round(Math.abs(n)).toLocaleString('en-US'); }
    function num(s){ return parseFloat(String(s).replace(/[^0-9.]/g,''))||0; }
    function haversine(la1,lo1,la2,lo2){ var R=3958.8,p=Math.PI/180,dLa=(la2-la1)*p,dLo=(lo2-lo1)*p,
      a=Math.sin(dLa/2)*Math.sin(dLa/2)+Math.cos(la1*p)*Math.cos(la2*p)*Math.sin(dLo/2)*Math.sin(dLo/2);
      return R*2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a)); }

    function calcDelivery(){
      var q=(addr&&addr.value||'').trim();
      if(q.length<4){ dNote.textContent='Enter a full address (street, city, ZIP).'; return; }
      addrGo.disabled=true; addrGo.textContent='...';
      fetch('https://photon.komoot.io/api/?limit=1&lang=en&q='+encodeURIComponent(q))
        .then(function(r){ return r.json(); })
        .then(function(j){
          addrGo.disabled=false; addrGo.textContent='Calculate';
          var f=j&&j.features&&j.features[0];
          if(!f||!f.geometry||!f.geometry.coordinates){ dNote.textContent='Address not found. Add city and ZIP and try again.'; deliveryFee=0; deliveryMiles=null; apply(true); return; }
          var c=f.geometry.coordinates, mi=haversine(SHOP_LAT,SHOP_LNG,c[1],c[0])*ROAD;
          deliveryMiles=Math.max(1,Math.round(mi));
          deliveryFee=DELIVERY_BASE+Math.round(deliveryMiles*MILE_RATE);
          dNote.innerHTML='~'+deliveryMiles+' mi from Los Angeles &middot; estimated delivery <b>'+money(deliveryFee)+'</b> (final fee confirmed at checkout).';
          apply(true);
        })
        .catch(function(){ addrGo.disabled=false; addrGo.textContent='Calculate'; dNote.textContent='Could not calculate right now, please try again.'; });
    }
    if(addrGo) addrGo.addEventListener('click', calcDelivery);
    if(addr){ addr.addEventListener('keydown', function(e){ if(e.key==='Enter'){ e.preventDefault(); calcDelivery(); } });
      addr.addEventListener('input', function(e){ e.stopPropagation(); }); }

    function parts(){
      var material=0, others=[];
      Array.prototype.forEach.call(breakEl.querySelectorAll('span'), function(sp){
        var b=sp.querySelector('b'); if(!b) return;
        var label=sp.textContent.replace(b.textContent,'').trim(), v=num(b.textContent);
        if(/panels?\s*\(material\)/i.test(label)){ material=v; return; }
        if(/pro install/i.test(label)) return;
        if(/install only/i.test(label)) return;
        if(/you save/i.test(label)) return;
        if(/delivery/i.test(label)) return;
        others.push([label, v]);
      });
      return { material:material, others:others };
    }

    function wa(text){ return 'https://wa.me/14243457142?text='+encodeURIComponent(text); }

    function apply(useCache){
      var p = (useCache && cache) ? cache : (cache = parts());
      var panels=parseInt(panelsEl.textContent,10)||0, othersSum=p.others.reduce(function(t,x){return t+x[1];},0);
      var finish=finishEl?finishEl.textContent.trim():'';

      var comboTotal=p.material+panels*LABOR_OURS+othersSum;
      var separate=p.material+panels*LABOR_ONLY+othersSum;
      var saved=separate-comboTotal, pct=separate>0?Math.round(saved/separate*100):0;
      if(saveBadge) saveBadge.textContent = saved>0 ? ('Save '+money(saved)) : 'Best value';

      var lines=[], total=0, extra='';
      if(mode==='panels'){
        lines.push(['Panels (material)', p.material]);
        total=p.material;
        if(buyEl){ buyEl.textContent='Add '+panels+' panel'+(panels>1?'s':'')+' to cart'; }
      } else if(mode==='install'){
        var lab=panels*LABOR_ONLY;
        lines.push(['Install only, labor ('+panels+' &times; $'+LABOR_ONLY+'/panel)', lab]);
        p.others.forEach(function(o){ lines.push(o); });
        total=lab+othersSum;
        if(buyEl){ buyEl.textContent='Send my install request to Max'; buyEl.href=wa('Hi Max! INSTALL ONLY (I already have the panels): '+panels+' panels, '+finish+', labor at $'+LABOR_ONLY+'/panel = '+money(lab)+(othersSum?' + extras '+money(othersSum):'')+(deliveryFee?' + delivery '+money(deliveryFee):'')+'. Estimated total '+money(total+deliveryFee)+'. Can you confirm?'); buyEl.target='_blank'; buyEl.rel='noopener'; }
      } else {
        lines.push(['Panels (material)', p.material]);
        lines.push(['Pro install, labor ('+panels+' &times; $'+LABOR_OURS+'/panel)', panels*LABOR_OURS]);
        p.others.forEach(function(o){ lines.push(o); });
        total=comboTotal;
        extra='<span class="wc-save-line">You save vs buying separately <b>'+money(saved)+' ('+pct+'%)</b></span>';
        if(buyEl){ buyEl.textContent='Send my design to Max'; buyEl.href=wa('Hi Max! COMBO (panels + install): '+panels+' panels, '+finish+'. Total '+money(comboTotal+deliveryFee)+' (saving '+money(saved)+' vs separate'+(deliveryFee?', incl delivery '+money(deliveryFee):'')+'). Can you confirm and schedule?'); buyEl.target='_blank'; buyEl.rel='noopener'; }
      }
      if(deliveryFee>0){ lines.push(['Delivery (~'+deliveryMiles+' mi)', deliveryFee]); total+=deliveryFee; }
      var html=''; lines.forEach(function(l){ html+='<span>'+l[0]+' <b>'+money(l[1])+'</b></span>'; });
      breakEl.innerHTML=html+extra;
      priceEl.textContent=money(total);
    }

    controls.addEventListener('input', function(){ apply(false); });
    controls.addEventListener('change', function(){ apply(false); });
    Array.prototype.forEach.call(btns, function(b){
      b.addEventListener('click', function(){
        mode=b.getAttribute('data-mode');
        Array.prototype.forEach.call(btns, function(x){ x.classList.toggle('is-on', x===b); });
        if(widthEl) widthEl.dispatchEvent(new Event('input',{bubbles:true}));
      });
    });
    setTimeout(function(){ apply(false); },60);
  });
})();
